import React, {useEffect, useState} from 'react';
import Slider from 'react-slick';

import Header from '../../global/Header';
import GridContainer from '../../global/GridContainer';
import ShareButton from '../../containers/ShareButton';
import LinkStyled from '../../components/LinkStyled';
import LinkStyledSimple from '../../components/LinkStyledSimple';
import LegalText from '../../components/LegalText';
import RelatedStory from '../../components/RelatedStory';
import useDetailData from '../../hooks/useDetailData';

import ProductTile from './ProductTile';

export default function Detail() {
  const [ loading, error, story, relatedStories, products ] = useDetailData();
  const [ sortedImages, setSortedImages ] = useState([]);

  useEffect(() => {
    setSortedImages([])
  },[story])

  if(loading) return (
    <main id="main" className="detail pt125 pt48@md mih100vh bgc-cream-dark">
      <p>Loading...</p>
    </main>
    );

  if(error) return (
    <main id="main" className="detail pt125  pt48@md mih100vh bgc-cream-dark">
      <p>Error: {error.message}</p>
    </main>
    );

  const {
    ID,
    petName,
    age,
    petType,
    breed,
    content,
    images, // need description
    dietaryGoals,
  } = story;

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };


  if(images && !sortedImages.length){
    const displayImages = images.filter(img => img.displayImage);
    const primary = displayImages.filter(img => img.isPrimary);
    const notPrimary = displayImages.filter(img => !img.isPrimary);

    setSortedImages([...primary, ...notPrimary]);
  }

  return (
  <main id="main" className="detail pt125 pt48@md mih100vh bgc-cream-dark">
    <GridContainer>
      <div className="detail__top-links df jcsb aic">
        <LinkStyledSimple to="/apps/truestories/story/search">
          &larr; All True Stories
        </LinkStyledSimple>
        <ShareButton />
      </div>
      <div className="detail__content maw800 ml-auto mr-auto tac mt24">
        <section className="detail__heading">
          <h1 className="fz64 fz32@sm lh0.77 ff-pgc mb16 ttc">
          { petName }
          </h1>
          <div className="ttu mb40 fz14@sm fz16 fw600">
            { breed.name } &mdash; Age { age }
          </div>
        </section>
        <section className="detail__content-slider mb40">
          <Slider {...settings}>
            {
            sortedImages.map(({ imageUrl, imageDescription }, i) => (
            <div
              key={i}
              className="content-slider__wrapper posr h400@sm h600 w800 bgc-black"
            >
              <img
                className="content-slider__img h100% w100% objc"
                src={imageUrl}
                alt={""}
              />
              <div className="content-slider__img-caption b20 mt16 fw500 fz20 fz18@sm ff-pgc">
                { imageDescription }
              </div>
            </div>
            ))
            }
          </Slider>
        </section>
        <section
          className="detail__content-text rte-content mb32 fz16 fz14@sm lh2.1 tal mt24"
          dangerouslySetInnerHTML={{ __html: content }}
        >
        </section>
        <section className="detail__dietary-needs mb40 tal">
          {
            dietaryGoals.map(({ ID, name }) => (
            <a
              key={ID}
              className="detail__dietary-needs-item dif aic jcc mb8 mr8 p8 tdn c-black bd2-s-black bd2-s-red-dark:h bgc-transparent trs-all-0.2s-eio fz12@sm fz14 fw600 ttu"
              href={`/apps/truestories/story/search?dietaryGoal=${ ID }`}
            >
              { name }
            </a>
            ))
          }
          {relatedStories.useBreedForViewAllLink
            ? (
              <a
                key={breed._id}
                className="detail__dietary-needs-item dif aic jcc mb8 mr8 p8 tdn c-black bd2-s-black bd2-s-red-dark:h bgc-transparent trs-all-0.2s-eio fz12@sm fz14 fw600 ttu"
                href={`/apps/truestories/story/search?breed=${ breed.ID }`}
              >
                { breed.name }
              </a>
            )
            : (
              <></>
            )
          }
        </section>
      </div>
      <section className="detail__products mb40">
        <div className='tac'>
          <h5 className="lh1.5 fw600 mb40 mb24@sm tac@md fz32 fz25@sm">
            THK Products { petName } loves
          </h5>
          {!products || products.length === 0
          ? (
            <div className="detail__content-text rte-content mb40 fz16 lh2.1">
              Looks like we don't have a product that fits all of your selections. Try adjusting your choices to see if that turns up some options.
            </div>
          )
          : (
            <div className={`products__item-list fxww jcc g16 df@sm fxdrr@sm ${products.length < 4 ? 'df' : 'aic dg gcolm4 gcolm3@md'}`}>
            {
            products.map((product, i) => <ProductTile key={i} product={product} length={products.length} />)
            }
            </div>
          )
          }
        </div>
      </section>
      <section className="detail__related-stories">
        <div className='tac'>
          <h3 className="fz40 fz28@sm lh1.1111 mb40 tac@md">
            Related True Stories
          </h3>
        </div>
        <div className="related-stories__container jcsb aic mb40 ml-auto mr-auto maw1200 miw-auto@md dg g24 gcolm3 gcolm2@md gcolm1@smx">
          {
            relatedStories.relatedStories
            .slice(0,4)
            .map((petData, i) => (
            <RelatedStory
              key={i}
              className={i === 3 ? 'dn db@md' : ''}
              petData={petData}
            />
            ))
          }
        </div>
        <div className="tac">
        {relatedStories.useBreedForViewAllLink
        ? (
        <LinkStyled to={`/apps/truestories/story/search?breed=${ breed.ID }`}>
            <span className="c-black">View All ({ relatedStories.count}) {breed.name} True Stories</span>
        </LinkStyled>
        )
        : (
        <LinkStyled to={`/apps/truestories/story/search`}>
        <span className="c-black">View All ({ relatedStories.count}) True Stories</span>
        </LinkStyled>
        )
        }
        </div>
      </section>
      <LegalText className="pb40" />
      <br/><br/><br/><br/><br/>
    </GridContainer>
  </main>
  )
}
